import styled from 'styled-components';
export var HiddenDiv = /*#__PURE__*/styled.div.withConfig({
  componentId: "plasma-ui__sc-1fy1cgr-0"
})(["position:fixed;display:inline-block;width:auto;letter-spacing:inherit;font-weight:inherit;font-family:inherit;white-space:pre;visibility:hidden;overflow:auto;"]);